// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"507":"d7f86766","723":"10ca0985","821":"507f7587"}[chunkId] + ".chunk.js";
};